import { Header } from "app/frame/Header/Header";
import { useBreakpoint } from "app/layout/hooks";
import React from "react";

export const HeaderContainer = () => {
    const desktop = useBreakpoint();

    return <Header desktop={desktop} />;
};
